import { DefaultService } from '@/services/DefaultService';

export default class AssOcorrenciaProdutoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	updateSituacao(assocorrenciaproduto) {
		return this._http.post(`${this._env}/agro/agro-assocorrenciaproduto/updatesituacao`, assocorrenciaproduto, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    findAll(column, order, page, limit, situacao, contexto = "agro", ...params) {
		return this._http.get( encodeURI(`${this._env}/${contexto}/agro-assocorrenciaproduto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllProdutosMedia(column, order, page, limit, idagro_ocorrencia, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/agro-assocorrenciaproduto/produtos-media-info?page=${page}&limit=${limit}&column=${column}&order=${order}&idagro_ocorrencia=${idagro_ocorrencia}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/agro/getcombo/agro-assocorrenciaproduto.json?param=${params}`), this._headers).then(res => {
      		return res.body;
		}, err => {
      		this.verifyError(err);
      		throw new Error('Problems while jobs are loading');
		});
	}

	findNaoAssociados(column, order, page, limit, idagro_ocorrencia, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/agro-assocorrenciaproduto/produtosnaoassociados?page=${page}&limit=${limit}&order=${order}&column=${column}&idagro_ocorrencia=${idagro_ocorrencia}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	find(id) {
		return this._http.get(`${this._env}/agro/agro-assocorrenciaproduto/${id}.json`, this._headers).then(res => {
      		return res.body;
    	}, err => {
      		this.verifyError(err);
      		throw new Error('Problems while jobs are loading');
    	});
	}

	save(form) {
		return this._http.post(`${this._env}/agro/agro-assocorrenciaproduto`, form, this._headers).then(res => {
      		return res.body;
		}, err => {
      		this.verifyError(err);
      		throw err;
		});
  	}

	findAllCount(idagro_ocorrencia){
		return this._http.get(`${this._env}/agro/agro-assocorrenciaproduto/produtos-count/${idagro_ocorrencia}`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

}